import { render } from "./SenderEdit.vue?vue&type=template&id=deaa33d2"
import script from "./SenderEdit.vue?vue&type=script&lang=js"
export * from "./SenderEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__